import { closeApp } from 'support/appUtils';
import { translate } from 'support/translate';
import AbstractModal from 'components/widgets/AbstractModal';

export default class ExitModal extends AbstractModal {
  override _setup() {
    this.title = translate('global.appExitMessage');
    this.confirmLabel = translate('global.appExitConfirmButton');
    this.cancelLabel = translate('global.appExitDismissButton');
    this.onCancel = closeApp;
  }
}
